import 'react-toastify/dist/ReactToastify.css';
import './index.css';

import {Navigate, Route, Routes, useLocation} from 'react-router-dom';

import { AnimatePresence } from 'framer-motion';
import ProtectedRoute from './utils/Protect';
import ScrollToTop from './components/scrollToTop';
import { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { publicRoutes } from './router/Router';

function App() {
  const location = useLocation();
  return (
    <Suspense fallback={<div style={{ backgroundColor: '#000', height: '100vh' }} />}>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {publicRoutes.map((route, index) => {
            const Page = route.component;
            let Element = <Page />;
            if (route.isPrivate) {
              Element = <ProtectedRoute>{Element}</ProtectedRoute>;
            }
            return <Route key={index} path={route.path} element={Element} />;
          })}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
      <ToastContainer />
    </Suspense>
  );
}
export default App;
